import { GridStoreMessageType } from "./GriddleStoreFront";
import { isAction, SuccessCode } from "./models";
var GriddleThreadedStoreCom = /** @class */ (function () {
    function GriddleThreadedStoreCom(storeFrontChangeCallback) {
        var _this = this;
        this.pendingActions = new Map();
        this.sendMessage = function (message) {
            return new Promise(function (resolve, reject) {
                _this.storeWorker.postMessage(message);
                if (isAction(message)) {
                    _this.pendingActions.set(message.actionId, { resolve: resolve, reject: reject });
                }
            });
        };
        /**
         * Handle worker messages
         * Inspect what type of message was received and dispatch to the appropriate method
         */
        this.onMessage = function (messageEvent) {
            var message = messageEvent.data;
            try {
                if (message) {
                    switch (message.type) {
                        case GridStoreMessageType.CHANGE:
                            _this.handleChangeResponse(message.payload);
                            break;
                        case GridStoreMessageType.ACTION:
                            _this.handleActionResponse(message.payload);
                            break;
                        default:
                            break;
                    }
                }
            }
            catch (e) {
                // TODO: implement error handling
                // this is the case where there is something wrong with a received message (probably object shape)
            }
        };
        /**
         * Handle worker errors
         * TODO: should implement this thing - maybe do some logging or such
         */
        this.onError = function (errorEvent) {
            // This is called by run time errors in the worker.. not to be used
            // for handling our own processing errors and such
            console.error(errorEvent.message);
        };
        this.handleActionResponse = function (actionResponse) {
            var pendingAction = _this.pendingActions.get(actionResponse.actionId);
            if (pendingAction) {
                switch (actionResponse.successCode) {
                    case SuccessCode.GOOD:
                        pendingAction.resolve(actionResponse.payload);
                        break;
                    case SuccessCode.BAD:
                        pendingAction.reject(actionResponse.payload);
                        break;
                    default:
                        break;
                }
                _this.pendingActions["delete"](actionResponse.actionId);
            }
        };
        // TODO: need a way to get a url for a worker file
        // UrlUtil is an app-core class that can do this, how could we do this in this here?
        this.storeWorker = new Worker("GriddleWorker.js", undefined);
        this.storeWorker.onmessage = this.onMessage;
        this.storeWorker.onerror = this.onError;
        this.handleChangeResponse = storeFrontChangeCallback;
    }
    GriddleThreadedStoreCom.create = function (callBack) {
        // singleton creation
        // There shouldn't be a need to recreate the storeRoom
        if (!GriddleThreadedStoreCom.storeCom) {
            GriddleThreadedStoreCom.storeCom = new GriddleThreadedStoreCom(callBack);
        }
        return GriddleThreadedStoreCom.storeCom;
    };
    return GriddleThreadedStoreCom;
}());
export { GriddleThreadedStoreCom };
//# sourceMappingURL=GriddleThreadedStoreCom.js.map